import styled from "styled-components"
import { TABLET_MAX_WIDTH, MOBILE_MIN_WIDTH } from "@constants"

export const StyledBlogWrappper = styled.div`
  margin: 0 auto;
  max-width: 78vw;
  padding-top: 4.75rem;

  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    max-width: 70vw;
  }

  @media only screen and (max-width: ${MOBILE_MIN_WIDTH}px) {
    max-width: 90vw;
  }
`

export const StyledBlogTitle = styled.h1`
  color: #252525;
  font-size: 64px;
  font-weight: 700;
  line-height: 77px;
  letter-spacing: 0.64px;

  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    font-size: 40px;
    line-height: 48px;
    letter-spacing: 0.8px;

  }

  @media only screen and (max-width: ${MOBILE_MIN_WIDTH}px) {
    font-size: 28px;
    line-height: 36px;
    letter-spacing: 0.56px;
  }
`

export const StyledBlogFilterContainer = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 40px;

  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    max-width: 90vw;
  }

  @media only screen and (max-width: ${MOBILE_MIN_WIDTH}px) {
    font-size: 35px;
  }
`

export const StyledBlogFilterCategory = styled.p``

export const StyledBlogFilterOption = styled.button`
  padding: 6px 0;
  text-align: center;
  cursor: pointer;
  letter-spacing: 0.8px;
  height: 36px;
  width: 105px;
  line-height: 0px;
  border: 1px solid #86723e;
  color: #86723e;
  gap: 15px;
  border-radius: 1px;
  background: ${({ isActive }) => isActive ? "rgba(196, 177, 128, 0.3)" : "#fff"} !important;

  &:active {
    background: rgba(196, 177, 128, 0.3) !important;
  }

  ${({ isActive }) => !isActive && `
    &:hover {
      background: rgba(196, 177, 128, 0.10) !important;
  }
  `}
`
export const StyledTabletAndMobileFilterButton = styled.button`
  display: flex;
  align-items: center;
  width: 312px;
  height: 40px;
  padding: 8px 32px;
  justify-content: center;
  border: 1px solid #c4b180;
  background: rgba(196, 177, 128, 0.1);
  cursor: pointer;
  
  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    width: 100%;
  }

  @media only screen and (max-width: ${MOBILE_MIN_WIDTH}px) {
    margin: 0;
  }
`

export const StyledTabletAndMobileFilterButtonText = styled.span`
  color: #86723e;
  text-align: center;
  font-family: Nunito Sans;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.32px;
`

export const StyledBlogArticlesWrapper = styled.div`
  max-width: 1300px;
`

export const CategoriesListContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 0.5rem;
`

export const CategoriesListBall = styled.div`
  width: 0.25rem;
  height: 0.25rem;
  background: #EDE8D9;
  border-radius: 50%;
` 